// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as PlaceOrderChain,
    DispatchCompletePlaceOrder,
    SetCartStatus,
    SetCreditCard,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export const XngPopulateCartExtraProps: any = (props: any) => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }
    const currentCarrierIdx = cart?.carriers?.findIndex(c => c.id === cart?.carrier?.id);

    const notes = state.xCheckout.notes || state.pages.checkoutShipping.editedCartNotes;
    const carrierAccount =
        currentCarrierIdx === 1 ? state.xCheckout.carrierAccount || cart.properties.carrierAccount : "";
    const additionalDetails =
        currentCarrierIdx === 2 ? state.xCheckout.additionalDetails || cart.properties.additionalDetails : "";
    const creditCardNickName = state.xCheckout.cardNickName || cart.properties.creditCardNickName;

    props.cartToUpdate = {
        ...props.cartToUpdate,
        notes,
        properties: {
            ...props.cartToUpdate.properties,
            carrierAccount,
            additionalDetails,
            creditCardNickName,
        },
    };
};

export const xClearCheckoutStatus = (props: any) => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/CompleteApplyPromotion",
        successMessage: "",
        errorMessage: "",
    });
    props.dispatch({
        type: "xCheckout/setCarrierAccount",
        carrierAccount: "",
    });
    props.dispatch({
        type: "xCheckout/setAdditionalDetails",
        additionalDetails: "",
    });
};

export const xSetCreditCard = (props: any) => {
    const state = props.getState();
    const { cartToUpdate } = props;
    if (
        cartToUpdate.paymentMethod?.isCreditCard &&
        !props.parameter.useBillingAddress &&
        state.xCheckout.cardAddress2
    ) {
        props.cartToUpdate = {
            ...props.cartToUpdate,
            properties: {
                ...props.cartToUpdate.properties,
                CreditCardBillingAddress2: state.xCheckout.cardAddress2,
            },
        };
    }
};

addToChainAfter(PlaceOrderChain, SetCartStatus, XngPopulateCartExtraProps);
addToChainAfter(PlaceOrderChain, DispatchCompletePlaceOrder, xClearCheckoutStatus);
addToChainAfter(PlaceOrderChain, SetCreditCard, xSetCreditCard);
